import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import AccountantDashboardSectionCustomComponents1 from '../components/custom-components/AccountantDashboardSectionCustomComponents1';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function AccountantDashboard() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <AccountantDashboardSectionCustomComponents1 />
    </React.Fragment>
  );
}

